const devMode = process.env.NODE_ENV !== 'production';

export function isDevMode(): boolean {
  return devMode;
}
